module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.$route.query.code) ? _c('div', [_c('h1', [_vm._v("授權成功，請稍後")])]) : _vm._e(), (_vm.$route.query.error) ? _c('div', [_c('h1', [_vm._v("授權失敗")]), _c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#666"
    }
  }, [_vm._v(_vm._s(_vm.$route.query.error))])]) : _vm._e(), _c('div', {
    staticClass: "loading-animation"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c5479e1"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/callback.vue
// module id = 566
// module chunks = 1